// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 35) return "static/js/03847e3fe538f85c8783.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"0f463b6674df9e43e741","135":"43d23d0033e37012daca","136":"b89608bb7fd4f29d1e8e"}[chunkId] + ".chunk.js";
};